<template>
  <div class="expansion">
    <div class="label row no-wrap items-center">
      <q-item
        :class="['col-grow', 'q-pl-sm', headerClass]"
        :to="to"
      >
        <q-item-section>
          <div
            class="ellipsis full-width cursor-pointer"
            @click="disable ? undefined : isOpen = !isOpen"
          >
            <span :class="{'text-primary': actionsDropdownState}">
              {{ label }}
            </span>

            <q-icon
              :name="isOpen ? 'expand_less' : 'expand_more'"
              :color="isOpen || disable ? 'grey' : 'primary'"
              size="20px"
            />
          </div>
        </q-item-section>
        <q-item-section
          v-if="$slots.header"
          class="middle"
        >
          <slot name="header"/>
        </q-item-section>
        <q-item-section
          v-if="actions.length"
          avatar
        >
          <ActionsDropdown
            :menu="actions"
            is-hover-action
            @input="actionsDropdownHandle"
          />
        </q-item-section>
      </q-item>
    </div>
    <div
      v-show="isOpen"
      class="body"
    >
      <slot/>
    </div>
  </div>
</template>

<script>
import ActionsDropdown from 'common/components/ActionsDropdown';

export default {
  name: 'AppExpansionItem',
  components: { ActionsDropdown },
  props: {
    label: {
      type: String,
      default: undefined,
    },
    headerClass: {
      type: String,
      default: 'header',
    },
    to: {
      type: [String, Object],
      default: undefined,
    },
    actions: {
      type: Array,
      default: () => ([]),
    },
    defaultOpened: {
      type: Boolean,
      default: false,
    },
    disable: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isOpen: false,
      actionsDropdownState: false,
    };
  },
  watch: {
    isOpen() {
      this.$emit('toggle', this.isOpen);
    },
  },
  created() {
    this.isOpen = this.defaultOpened;
  },
  methods: {
    actionsDropdownHandle(event) {
      this.actionsDropdownState = event;
    },
  },
};
</script>

<style lang="scss" scoped>
.expansion {
  .header {
    font-size: 16px;
    font-weight: 400;
    padding: 29px 25px;

    .middle {
      flex: auto;
      flex-direction: row;
      align-items: center;
      column-gap: 20px;
      justify-content: end;
    }
  }

  .body {
    background: $grey-6;
    border-radius: $radius-10;
    margin: 0 10px 10px;
    padding: 30px 25px 35px;
  }

  .label {
    width: 100%;

    .q-router-link--exact-active {
      color: $grey !important;
    }

    .q-link:hover {
      color: $primary !important;
    }
  }
}
</style>
